/**
 * Centralized dynamic loader for @td/websdk.
 * Caches the module promise to avoid duplicate imports and ensures consistent chunk naming.
 *
 * Usage:
 *   const { amplitude, fetchMemberNavigation } = await loadWebsdk();
 */

let websdkPromise;

export function loadWebsdk() {
    if (!websdkPromise) {
        websdkPromise = import(
            /* webpackChunkName: "websdk-async" */
            '@td/websdk'
        ).catch(err => {
            websdkPromise = undefined; // eslint-disable-line no-undefined
            // eslint-disable-next-line no-console
            console.error('WebSDK chunk load failed:', err);
        });
    }

    return websdkPromise;
}
